import script from "./CustomerMembershipTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerMembershipTab.vue?vue&type=script&setup=true&lang=js"

import "../../components/customers/record/recordLayout.css?vue&type=style&index=0&id=782740d4&scoped=true&lang=css&external"
import "./CustomerMembershipTab.vue?vue&type=style&index=1&id=782740d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-782740d4"]])

export default __exports__

/* vue-cli-plugin-import-components */

import BasicSpinner from "@/components/BasicSpinner.vue";
import MealPlanInfoCard from "@/components/customers/MealPlanInfoCard.vue";
import PassBenefits from "@/components/customers/PassBenefits.vue";
import PassInfoCard from "@/components/customers/PassInfoCard.vue";
import RecordButton from "@/components/customers/record/RecordButton.vue";
import RecordCard from "@/components/customers/record/RecordCard.vue";
import RecordRow from "@/components/customers/record/RecordRow.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import TheModal from "@/components/TheModal.vue";
script.components = Object.assign({}, { BasicSpinner, MealPlanInfoCard, PassBenefits, PassInfoCard, RecordButton, RecordCard, RecordRow, SelectInput, TheModal }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicSpinner, MealPlanInfoCard, PassBenefits, PassInfoCard, RecordButton, RecordCard, RecordRow, SelectInput, TheModal }, script.__o.components);}